// Define the potential locales that we have translation data for in ../locales,
// the locales in this map are always available on the home/search pages.
// The translations that are available for each documentation set are a
// subset of these locales that are defined in the _siteconfig.yaml.
export const LOCALES = {
  'en-US': 'English',
  'ja-JP': '日本語',
  'ko-KR': '한국어',
  'vi-VN': 'Tiếng Việt',
  'zh-CN': '简体中文',
};

export const DEFAULT_LOCALE = 'en-US';

export type SUPPORTED_LOCALES = keyof typeof LOCALES;

// NOTE: Each locale value must have a corresponding import statement in packages/web/src/components/content-renderer/content-renderer.tsx
export const LOCALE_TO_DAYJS_LOCALE: Record<SUPPORTED_LOCALES, string> = {
  'en-US': 'en',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'vi-VN': 'vi',
  'zh-CN': 'zh-cn',
};

export const LOCALE_PATTERN = /^[a-z]{2}(-[A-Z]{2})?$/;
